var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMy = function SvgIconMy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.479 12H24c0-1.083-.144-2.132-.413-3.13H11.479zM11.479 5.739h10.76a12 12 0 0 0-2.769-3.13H11.48zM12.001 24c2.824 0 5.42-.976 7.47-2.608H4.531A11.95 11.95 0 0 0 12.001 24M1.762 18.26h20.477a12 12 0 0 0 1.348-3.13H.414c.3 1.116.758 2.168 1.348 3.13"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 12V0C5.373 0 0 5.373 0 12z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98 10.27a2.967 2.967 0 1 1 1.412-5.577 3.652 3.652 0 1 0 0 5.222c-.42.227-.901.356-1.412.356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.816 5.217.527 1.102 1.19-.275L10 7.143l.957.759-1.191.268.003 1.221-.953-.764-.952.764.003-1.22-1.191-.27.957-.758L7.1 6.044l1.19.275z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconMy;